import PublicationsCriteria from "../../components/Board/PublicationsCriteriaPage";

export default function PublicationsCriteriaPage() {
  return <PublicationsCriteria />;
}
